import React, { useState, useEffect, useRef, useCallback } from "react";
import CustomButton from "./CustomButton";
import MenuScreen from "./MenuScreen";
import LoaderScreen from "./LoaderScreen";
import ModalScreen from "./ModalScreen";
// import { fetchContent } from "../services/api";
import HomePage from "./HomeScreen";
import selectedIcon from "../assets/selectedIcon.png";
import { Translate } from "./LanguageChanger";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import logoutIcon from "../assets/Logout-Icon.png";
import Wrapper from "./shared/Wrapper";
import { getUserProfile } from "../services/services";
import AuthFailModal from "./AuthFailModal";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

let initialCall = true;

const MyProfile = ({ navigate, isLogedIn }) => {
  const [confirmedSelection, setConfirmedSelection] = useState(null);
  const [screen, setScreen] = useState();
  const [data, setData] = useState({});
  const [isMouseMode, setIsMouseMode] = useState(false);
  const [state, setState] = useState({
    isEditSelected: false,
    isDeleteSelected: false,
    shouldCloseMenu: true,
    shouldShowModal: false,
    shouldShowAuthModal: false,
    updateData: [],
    errTitle: "",
    errDescription: "",
    errIcon: "",
    button: ["Logout", "Cancel"],
    iconWdth: "",
    iconHeight: "",
    shouldShowFocus: true,
    shouldAddEventListener: true,
  });
  const {
    isEditSelected,
    isDeleteSelected,
    shouldCloseMenu,
    shouldShowModal,
    errTitle,
    errDescription,
    errIcon,
    button,
    iconWdth,
    iconHeight,
    updateData,
    shouldShowFocus,
    shouldShowAuthModal,
    shouldAddEventListener,
  } = state;


  const user_details = JSON.parse(
    localStorage.getItem("user_details")
  )?.user_profiles;
  // const user_details = JSON.parse(localStorage.getItem("user_details"));
  // const user_profile = JSON.parse(user_details);

  // const updatedMyprofile = JSON.parse(localStorage.getItem("updateMyProfile"));
  const updatedMyprofile = localStorage.getItem("updateMyProfile")
    ? JSON.parse(localStorage.getItem("updateMyProfile")).data
    : null;

  // const user_profile = updatedMyprofile ? updatedMyprofile.data : user_details.user_profiles;

  const user_profile = updatedMyprofile ? updatedMyprofile : user_details;

  console.log("user_profile", user_profile);

  const savedProfile = JSON.parse(localStorage.getItem("myProfile"));

  const [profiles, setProfiles] = useState(() => {
    try {
      const user_details = JSON.parse(localStorage.getItem("user_details"))?.user_profiles;
      const updatedMyprofile = localStorage.getItem("updateMyProfile")
        ? JSON.parse(localStorage.getItem("updateMyProfile")).data
        : null;
      const user_profile = updatedMyprofile ? updatedMyprofile : user_details;
      
      return user_profile?.map((profile) => ({
        name: profile.username,
        image: profile.profile,
        isKids: profile.is_kid,
        profileId: profile.profile_id,
        is_default: profile.is_default, // Added for check later
        username: profile.username // Added for check later
      })) || [];
    } catch (e) {
      return [];
    }
  });

  // useEffect(() => {
  //   console.log("profil33es", profiles)
  // }, [])

  const profileRefs = useRef([]);
  if (profileRefs.current.length !== profiles.length) {
      profileRefs.current = profiles.map((_, i) => profileRefs.current[i] ?? React.createRef());
  }
const initialSelectedIndex = savedProfile
  ? user_profile?.findIndex(
      (profile) => profile.username === savedProfile.name
    )
  : 0;


  // Added only selected profile

const [selectedElementIndex, setSelectedElementIndex] = useState(
  initialSelectedIndex >= 0 ? initialSelectedIndex : 0
);

  const addProfileRef = useRef(null);
  const editButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);


  useEffect(() => {
    // Matomo Event
    sendTestMatomoEvent({
      eventCategory: `Page`,
      eventAction: `View`,
      eventName: `MyProfile`,
      url: "profile",
    });

    // API Call Function defined inside to avoid dependency issues
    const fetchProfileData = async () => {
        // Safe check for profile ID
        if (!profiles || profiles.length === 0) return;
        
        const userId = profiles[0].profileId; // Assuming taking first profile ID or main user ID logic
        if(!userId) return;

        try {
          const response = await getUserProfile(userId);
          
          if (!response.success && !response.status) {
            handleAuthFailLogout();
            return;
          }

          if (response.statusCode === 200) {
            localStorage.setItem("updateMyProfile", JSON.stringify(response));
            MenuScreen.ReseTfocus(-1);
            setState((prevState) => ({
              ...prevState,
              updateData: response.data,
              shouldShowModal: false,
            }));
            
            // Note: Hum profiles state ko update nahi kar rahe yahan taaki re-render loop na ho.
            // Agar profiles update karna zaroori hai API ke baad, toh usse sambhal ke karna padega.
          }
        } catch (error) {
          handleAuthFailLogout();
          console.error("Error fetching data:", error);
        }
    };

    fetchProfileData();

  }, []); // Empty Array = Zindagi mein ek baar chalega. NO LOOP.


   const sendMatomoEvent = (event) => {
    const { category, action, name } = event;
    console.log("Matomo Event", category, action, name);
    sendTestMatomoEvent({ eventCategory: category, eventAction: action, eventName: name });
  };

  const navigateToScreen = (screen, data = {}) => {
    setScreen(screen);
    setData(data);
    window.removeEventListener("keydown", MyProfileKeyHandler);
  };

  const updateloadData = async () => {
    let timeStamp = "0000000000"
    if(!initialCall){
      timeStamp =(Date.now()) 
    }

    const userId = profiles.profileId;
    const getCountry = localStorage.getItem("country");
    let myHeaders = {
      platform: "0",
      iskid: "0",
      age: "12",
      country: getCountry,
      Langid: "1",

      timestamp: "0000000000",
      // profileid: user_details["user_profiles"][0]["profile_id"],
      // Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      // "Content-Type": "application/json",
    };

    try {
      // const [response] = await Promise.all([
      //   fetchContent(
      //     `/V1/getUserProfile/lastupdated/0000000000/userId/${userId}`,
      //     "GET",
      //     myHeaders
      //   ),
      // ]);
      const response = await getUserProfile(userId);
      console.log("updatedMyProfile...", response);
      if (!response.success && !response.status) {
        console.log("test updatedMyProfile...");
        handleAuthFailLogout();
      }
      if (response.statusCode === 200) {
        console.log("updatedMyProfile...", response);
        localStorage.setItem("updateMyProfile", JSON.stringify(response));
        MenuScreen.ReseTfocus(-1);
        setState((prevState) => ({
          ...prevState,
          updateData: response.data,
          shouldShowModal: false,
        }));
      }

      // Matomo Event
    sendMatomoEvent({
      category: `Page`,
      action: `View`,
      name: `MyProfile`,
    });
    } catch (error) {
      handleAuthFailLogout();
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    updateloadData();
  }, []);

  const handleMouseMove = () => {
    if (!isMouseMode) {
      setIsMouseMode(true);
    }
  };


  const MyProfileKeyHandler = (event) => {
    setIsMouseMode(false);
    if(shouldShowModal || shouldShowAuthModal||!shouldCloseMenu) return;
    if (event.keyCode !== undefined) {
      // if (!shouldShowFocus) {
      //   setSelectedElementIndex(0);
      //   setState((prevState) => ({
      //     ...prevState,
      //     shouldShowFocus: true,
      //   }));
      // }
      switch (event.keyCode) {
        case 13:
          if (
            selectedElementIndex < profiles.length &&
            !isEditSelected &&
            !isDeleteSelected &&
            shouldShowFocus
          ) {
            MenuScreen.ReseTfocus(4);
            setConfirmedSelection(selectedElementIndex);
            localStorage.setItem(
              "proImg",
              profiles[selectedElementIndex].image
            );
            localStorage.setItem(
              "myProfile",
              JSON.stringify(profiles[selectedElementIndex])
            );
            window.removeEventListener("keydown", MyProfileKeyHandler);

            const profile = profiles?.[selectedElementIndex];

            if (profile) {
              sendMatomoEvent({
                category: "Profile",
                action: "Switch",
                name: `${profile.profileId}/${profile.name}/${
                  profile.isKids == 0 ? "Adult" : "Child"
                }`,
              });
            }

            navigate("HomePage");
          } else if (
            selectedElementIndex === profiles.length &&
            !isEditSelected &&
            !isDeleteSelected &&
            shouldShowFocus
          ) {
            window.removeEventListener("keydown", MyProfileKeyHandler);
            navigate("AddProfile");
          } else if (isEditSelected && !isDeleteSelected && !shouldShowFocus) {
            // (selectedElementIndex === profiles.length + 1) {
            window.removeEventListener("keydown", MyProfileKeyHandler);
            navigate("EditProfile");
          } else if (!isEditSelected && isDeleteSelected && !shouldShowFocus) {
            //(selectedElementIndex === profiles.length + 2) {
            window.removeEventListener("keydown", MyProfileKeyHandler);
            navigate("DeleteProfile");
          }
          break;
      case 39:
          if (selectedElementIndex < profiles.length && profiles.length !== 5 && !isEditSelected && !isDeleteSelected ) {
            setSelectedElementIndex((prevIndex) => prevIndex + 1);
          }
            else if (selectedElementIndex < profiles.length - 1) {
             setSelectedElementIndex((prevIndex) => prevIndex + 1);
           }
          break;
        case 37:
          if (
            selectedElementIndex > 0 &&
            selectedElementIndex <= profiles.length &&
            !isEditSelected &&
            !isDeleteSelected
          ) {
            setSelectedElementIndex((prevIndex) => prevIndex - 1);
          } else if (isEditSelected || isDeleteSelected) {
            setState((prevState) => ({
              ...prevState,
              isEditSelected: false,
              isDeleteSelected: false,
              shouldCloseMenu: false,
              shouldAddEventListener: false,
            }));
            window.removeEventListener("keydown", MyProfileKeyHandler);
            MenuScreen.SetFocus(false);
          } else if (selectedElementIndex === 0) {
            setState((prevState) => ({
              ...prevState,
              shouldShowFocus: false,
              shouldCloseMenu: false,
              shouldAddEventListener: false,
            }));
            window.removeEventListener("keydown", MyProfileKeyHandler);
            MenuScreen.SetFocus(false);
          }
          break;
        case 38: // Up Arrow
          if (isDeleteSelected && !isEditSelected) {
            setState((prevState) => ({
              ...prevState,
              isEditSelected: true,
              isDeleteSelected: false,
            }));
          } else if (isEditSelected && !isDeleteSelected) {
            setState((prevState) => ({
              ...prevState,
              isEditSelected: false,
              shouldShowFocus: true,
            }));
          }
          break;
        case 40: // Down Arrow
        // if (document.activeElement === addProfileRef?.current) {
        //     return;
        //   } 

          if (document.activeElement === addProfileRef?.current && selectedElementIndex === profiles.length &&
            !isEditSelected &&
            !isDeleteSelected ) {
            return;
          }
             if (!isDeleteSelected && !isEditSelected) {
            setState((prevState) => ({
              ...prevState,
              shouldShowFocus: false,
              isEditSelected: true,
            }));
          } else if (isEditSelected && !isDeleteSelected) {
            const currentProf = profiles[selectedElementIndex];
            const isDefault = currentProf?.is_default === 1;
            const isCurrentProfile = confirmedSelection === selectedElementIndex ||
              JSON.parse(localStorage.getItem("myProfile"))?.name === currentProf?.name;
              
            if(isDefault || isCurrentProfile) {
                return;
            }
            setState((prevState) => ({
              ...prevState,
              isEditSelected: false,
              isDeleteSelected: true,
            }));
          } 
          break;
        case 461:
        case 8:
        case 10009:
          handleBackButton();
          break;
        default:
          break;
      }
    }
  };

  const handleOk = () => {
    MenuScreen.ReseTfocus(4);
    window.removeEventListener("keydown", MyProfileKeyHandler);
    navigate("HomePage");
  };

  const addProfile = () => {
    navigate("AddProfile");
    window.removeEventListener("keydown", MyProfileKeyHandler);
  };

  const editProfile = () => {
    window.removeEventListener("keydown", MyProfileKeyHandler);
    navigate("EditProfile");
  };

  const deleteProfile = () => {
    window.removeEventListener("keydown", MyProfileKeyHandler);
    navigate("DeleteProfile");
  };

  useEffect(() => {
    if(shouldShowModal || shouldShowAuthModal) return;
    if (
      selectedElementIndex < profiles.length &&
      profileRefs?.current[selectedElementIndex]?.current
    ) {
      profileRefs?.current[selectedElementIndex]?.current.focus();
    } else if (
      selectedElementIndex === profiles?.length &&
      addProfileRef?.current
    ) {
      addProfileRef?.current.focus();
    } else if (
      selectedElementIndex === profiles?.length + 1 &&
      editButtonRef?.current
    ) {
      editButtonRef?.current.focus();
    } else if (
      selectedElementIndex === profiles.length + 2 &&
      deleteButtonRef?.current
    ) {
      deleteButtonRef?.current.focus();
    }
    // updateloadData();
    if (shouldAddEventListener && shouldCloseMenu || !shouldShowModal) {
      // setTimeout(() => {
        // window.removeEventListener("keydown", MyProfileKeyHandler);
        window.addEventListener("keydown", MyProfileKeyHandler);
      // }, 200);
    }
    return () => {
      window.removeEventListener("keydown", MyProfileKeyHandler);
    };
  }, [
    selectedElementIndex,
    profiles.length,
    shouldShowFocus,
    isDeleteSelected,
    isEditSelected,
    shouldAddEventListener,
    shouldCloseMenu,
    shouldShowModal,
    shouldShowAuthModal
  ]);

  const handleMenuselection = (selectedMenu) => {
    switch (selectedMenu) {
      case "Login":
        navigate("LoginScreen");
        break;
      case "Profile":
        navigate("ProfileScreen");
        break;
      case "Search":
        navigate("SearchScreen");
        break;
      case "Live":
        navigate("LiveScreen");
        break;
      case "LiveEvents":
        navigate("LiveEventsScreen");
        break;
      case "Home":
        navigate("HomePage");
        break;
      case "Watchlist":
        break;
      case "Categories":
        navigate("CategoryScreen");
        break;
      case "Settings":
        navigate("SettingsScreen");
        break;
      case "Logout":
        break;
      default:
        break;
    }
  };

  const handleRightButton = () => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowFocus: true,
      shouldAddEventListener: true,
    }));
    MenuScreen.SetFocus(true);
  };

  const handleExit = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Exit",
      errDescription: "ExitMsg",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Yes", "No"],
    }));
    MenuScreen.SetFocus(true);
  }, []);

  const handleBackButton = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      shouldCloseMenu: false,
      shouldShowFocus: false,
      isEditSelected: false,
      isDeleteSelected: false,
    }));
    MenuScreen.SetFocus(false);
    window.removeEventListener("keydown", MyProfileKeyHandler);
  }, [])

  const handleLogout = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: true,
      errTitle: "Logout",
      errDescription: "cofirm-logout",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Logout", "Cancel"],
    }));
    MenuScreen.SetFocus(true);
  }, []);

  const handleAuthFailLogout = useCallback(() => {
    console.log("handleAuthFailLogout......");
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldCloseMenu: true,
      shouldShowModal: false,
      shouldShowAuthModal: true,
      shouldAddEventListener: false,
      // errTitle: "Session-Expired",
      errDescription: "session-desc",
      errIcon: logoutIcon,
      iconWdth: "109px",
      iconHeight: "109px",
      button: ["Login"],
    }));
    MenuScreen.SetFocus(true);
  }, [])

  // const modalOKButtonHandler = async (action) => {
  //   let Logout = action?.props?.langKey;
  //   console.log(action, "action in modalOKButtonHandler");

  //   switch (Logout ? Logout : action) {
  //     case "Login":
  //       const myProfile = localStorage.getItem("myProfile");
  //       // await sendTestMatomoEvent({
  //       //   eventCategory: "Page",
  //       //   eventAction: "View",
  //       //   eventName: "LoginPopup",
  //       //   url: "Home",
  //       // });
  //       localStorage.removeItem("user_details");
  //       localStorage.removeItem("userId");
  //       localStorage.removeItem("profileId");
  //       localStorage.clear();
  //       window.appReload();
  //       navigate("LoginScreen");
  //       break;

  //     case "Logout":
  //       console.log("Logout....");
  //       logoutUser();
  //       localStorage.removeItem("JWTToken");
  //       localStorage.removeItem("userInfo");
  //       // const getCountry = localStorage.getItem("country");
  //       // let headers = {
  //       //   iskid: "0",
  //       //   Langid: "1",
  //       //   "Content-Type": "application/json",
  //       //   country: getCountry,
  //       // };
  //       // Promise.all([fetchContent("/V1/logout", "POST", headers)]);
  //       // console.log("Logout", Promise.all([fetchContent("/V1/logout", "POST", headers)]))

  //       localStorage.clear();
  //       window.appReload();
  //       MenuScreen.ReseTfocus(4);
  //       MenuScreen.SetFocus(true);
  //       handleMenuselection("Login");
  //       break;
  //     case "Yes":
  //       console.log("exit application..");
  //       exitApplication();
  //       // window.close();
  //       // navigate("LoginScreen");
  //       break;
  //     default:
  //       break;
  //   }
  // };

  const modalOKButtonHandler = (action) => {
    // if (window.tizen) {
    //   sendTestMatomoEvent({ action_name: `App - End`, url: "profile" });
    //   window.tizen.application.getCurrentApplication().exit();
    // } else {
    //   sendTestMatomoEvent({ action_name: `App - End`, url: "profile" });
    //   window.close();
    // }
    switch (action) {
      case "Login":
        localStorage.removeItem("JWTToken");
        localStorage.removeItem("userInfo");
        window.appReload();
        navigate("LoginScreen");
        break;
      case "Logout":
        console.log("Logout....");
        sendTestMatomoEvent({
          eventCategory: "App",
          eventAction: "Logout",
          url: "profile",
        });
        localStorage.removeItem("JWTToken");
        localStorage.removeItem("userInfo");
        const getCountry = localStorage.getItem("country");
        let headers = {
          iskid: "0",
          Langid: "1",
          "Content-Type": "application/json",
          country: getCountry,
        };
        // Promise.all([fetchContent("/V1/logout", "POST", headers)]);
        localStorage.clear();
        window.appReload();
        MenuScreen.ReseTfocus(4);
        MenuScreen.SetFocus(true);
        handleMenuselection("Login");
        break;

        case "Yes":
        console.log("exit application..");
        exitApplication();
        // window.close();
        // navigate("LoginScreen");
        break;
      default:
        break;
    }
  };

    const exitApplication = () => {
      console.log("exitApp...");
      if (window.tizen) {
        window.tizen.application.getCurrentApplication().exit();
        sendMatomoEvent({ category: "App", action: "End", name: "" });
  
      } else {
        window.close();
        sendMatomoEvent({ category: "App", action: "End", name: "" });
  
      }
    };


  const modalCANCELButtonHandler = () => {
    console.log("modalCANCELButtonHandler...myprofile...");
    MenuScreen.ReseTfocus(1);
    // MenuScreen.ReseTfocus(-1);
    setState((prevState) => ({
      ...prevState,
      shouldShowModal: false,
      shouldShowFocus: true,
    }));
    // MenuScreen.SetFocus(false);
    window.addEventListener("keydown", MyProfileKeyHandler);
  };

  const styles = {
    container: {
      backgroundImage: `url(${solidbackgroundimg})`,
      color: "white",
      backgroundColor: "#000",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      overflow: "hidden",
    },
    profilesContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "2rem",
    },
    profileCard: {
      backgroundColor: "#0E1653",
      borderRadius: "10px",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // border: "2px solid white",
      width: "151px",
      height: "151px",
      padding: "0px",
      margin: "0px",
      backgroundSize: "cover",
      outline: "none",
    },
    profileName: {
      marginTop: "10px",
      fontFamily: "Anek Latin",
      fontWeight: 500,
      fontSize: "20px",
    },
    kidsBadge: {
      backgroundColor: "#ffcc00",
      borderRadius: "10px",
      padding: "2px 8px",
      position: "absolute",
      bottom: "25px",
      left: "50%", // Move to the center horizontally
      transform: "translateX(-50%)", // Adjust back by 50% of its own width
      fontFamily: "Shojumaru",
      fontWeight: 400,
      color: "rgba(255, 255, 255, 1)",
    },

    addProfile: {
      backgroundColor: "#0E1653",
      justifyContent: "center",
    },
    addProfileIcon: {
      fontSize: "50px",
    },
    focusStyle: {
      outline: "3px solid rgba(255, 255, 255, 1)",
      margin: "0px",
      padding: "0px",
      boxSizing: "border-box",
      backgroundSize: "cover",
      // width: "151px",
      // height: "151px",
    },
    buttonStyle: {
      backgroundColor: "orange",
      border: "none",
      padding: "10px 20px",
      margin: "5px",
      borderRadius: "5px",
      cursor: "pointer",
      outline: "none",
    },
    deleteButtonStyle: {
      backgroundColor: "#ff4040",
    },
    selectedIcon: {
      position: "absolute",
      width: "40px",
      height: "40px",
      left: "7.9rem",
      bottom: "1rem",
    },
  };

  const userProfiles =
    JSON.parse(localStorage.getItem("updateMyProfile"))?.data || {};

  return (
    <div style={styles.container} onMouseMove={handleMouseMove}>
      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
        `}
      </style>
      <div
        style={{
          alignContent: "center",
          alignItems: "center",
          position: "relative",
          textAlign: "center",
          margin: "0px",
          padding: "0px",
          boxSizing: "border-box",
          top: "15%",
          display:"flex",
          flexDirection:"column",
          height:"100vh",
          gap:"124px"
        }}
      >
        <h1
          style={{
            fontFamily: "Anek Latin",
            fontWeight: 500,
            fontSize: "32px",
            color: "rgba(255, 255, 255, 1)",
            position: "relative",
            // bottom: "10vh"
          }}
        >
          <Translate langKey={"My-Profile"} />
        </h1>
        <div style={styles.profilesContainer}>
          {profiles?.map((profile, index) => (
            <div
              key={index}
              style={{
                margin: "0px",
                padding: "0px",
                position: "relative",
                zIndex: 1,
              }}
            >
              <Wrapper
                style={{
                    ...(selectedElementIndex === index && shouldShowFocus
                    ? { ...styles.profileCard }
                    : styles.profileCard),
                    pointerEvents: isMouseMode ? "auto" : "none"
                }}
                tabIndex={0}
                ref={profileRefs.current[index]}
                id={`profile_${index}`}
                onClick={(e) => {
                  localStorage.setItem("myProfile", JSON.stringify(profile));
                  setConfirmedSelection(index);
                  handleOk();
                }}
                // onKeyDown={MyProfileKeyHandler}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    // setConfirmedSelection(index);
                    localStorage.setItem("myProfile", JSON.stringify(profile));
                    // setSelectedElementIndex(index);
                    setConfirmedSelection(index); // This sets the selected avatar
                  }
                }}
                // onMouseLeave={() => {
                //   setState((prev) => ({
                //     ...prev,
                //     shouldShowFocus: false,
                //   }));
                // }}
                // Added for magic remote hover issue 02/10/25 check if works
                onMouseEnter={() => {
                  if (isMouseMode) {
                    setSelectedElementIndex(index);
                    setState((prev) => ({
                        ...prev,
                        shouldShowFocus: true,
                        isEditSelected: false,
                        isDeleteSelected: false
                    }));
                  }
                }}
              >
                <img
                  src={profile.image}
                  alt={profile.name}
                  style={{
                    ...(selectedElementIndex === index && shouldShowFocus
                      ? { ...styles.focusStyle }
                      : {}),
                    width: "151px",
                    height: "151px",
                    borderRadius: "10px",
                    boxSizing: "border-box",
                    backgroundSize: "cover",
                  }}
                />
                {(confirmedSelection === index ||
                  JSON.parse(localStorage.getItem("myProfile"))?.name ===
                    profile.name) && (
                  <img
                    src={selectedIcon} // Replace with the actual path to your checkmark icon
                    alt="Selected"
                    style={styles.selectedIcon}
                  />
                )}
                {/* Render the selected icon only if this avatar is confirmed as selected */}
                {/* {(confirmedSelection === index || (JSON.parse(localStorage.getItem("myProfile"))?.name === profile.name)) && (
                  <img
                    src={selectedIcon} // Replace with the actual path to your checkmark icon
                    alt="Selected"
                    style={styles.selectedIcon}
                  />
                )} */}
              </Wrapper>
              <div style={styles.profileName}>
                {profile.name.length > 10
                  ? profile.name.slice(0, 10) + "..."
                  : profile.name}
                {profile.isKids === 1 && <p style={styles.kidsBadge}>KIDS</p>}
              </div>
            </div>
          ))}
          {profiles.length < 5 && (
            <Wrapper
              myProfile="true"
              style={{ 
                position: "relative", 
                bottom: "1rem", 
                zIndex: 1,
                pointerEvents: isMouseMode ? "auto" : "none" 
              }}
            >
              <div
                style={{
                  ...(selectedElementIndex === profiles.length && shouldShowFocus
                    ? {
                        ...styles.profileCard,
                        ...styles.addProfile,
                        ...styles.focusStyle,
                      }
                    : { ...styles.profileCard, ...styles.addProfile }),
                  pointerEvents: isMouseMode ? "auto" : "none" 
                }}
                ref={addProfileRef}
                tabIndex={0}
                onClick={addProfile}
                onMouseEnter={() => {
                    if (isMouseMode) {
                        setSelectedElementIndex(profiles.length);
                        setState((prev) => ({
                            ...prev,
                            shouldShowFocus: true,
                            isEditSelected: false,
                            isDeleteSelected: false
                        }));
                    }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    // Handle adding a new profile logic here
                  }
                }}
              >
                <div style={styles.addProfileIcon}>+</div>
                <div style={styles.profileName}>
                  <Translate langKey={"Add-Profile"} />
                </div>
              </div>
            </Wrapper>
          )}
        </div>
        <div
          style={{
            margin: "0px",
            padding: "0px",
            position: "relative",
            zIndex: 1,
          }}
        >
          {selectedElementIndex !== profiles.length && (
            <div
             style={{ pointerEvents: isMouseMode ? "auto" : "none" }}
             onMouseEnter={() => {
                if (isMouseMode) {
                    setState(prev => ({
                        ...prev,
                        isEditSelected: true,
                        isDeleteSelected: false,
                        shouldShowFocus: false
                    }));
                }
             }}
             >
              <CustomButton
                ref={editButtonRef}
                navigateTo="/login"
                fontSize="24px"
                defaultSelected={isEditSelected}
                // width="22vw"
                height="7vh"
                // top="6vh"
                // left="0vw"
                position="relative"
                style={{
                  width: "30.83vw",
                }}
                disableHoverOutline={true} 
                onClick={editProfile}
                onKeyDown={MyProfileKeyHandler}
              >
                <Translate langKey={"Edit-Profile"} />
              </CustomButton>
            </div>
          )}
          {/* {selectedElementIndex < profiles.length &&  */}
          {console.log("user_profile 595", user_profile)}
          {console.log("selectedElementIndex 595", selectedElementIndex)}
          {console.log("userProfiles 595", userProfiles)}
          {user_profile[selectedElementIndex]?.is_default === 0 &&
            user_profile?.find((data) => data.is_default === 0) &&
            !(
              confirmedSelection === selectedElementIndex ||
              JSON.parse(localStorage.getItem("myProfile"))?.name ===
                user_profile[selectedElementIndex]?.username
            ) && (
              <div
               style={{ pointerEvents: isMouseMode ? "auto" : "none" }}
               onMouseEnter={() => {
                    if (isMouseMode) {
                        setState(prev => ({
                            ...prev,
                            isDeleteSelected: true,
                            isEditSelected: false,
                            shouldShowFocus: false
                        }));
                    }
                }}
               >
                <CustomButton
                  ref={deleteButtonRef}
                  navigateTo="/login"
                  fontSize="24px"
                  defaultSelected={isDeleteSelected}
                  // width="22vw"
                  height="7vh"
                  top="2vh"
                  // left="0vw"
                  position="relative"
                  style={{
                    width: "30.83vw",
                  }}
                  disableHoverOutline={true} 
                  onClick={deleteProfile}
                  onKeyDown={MyProfileKeyHandler}
                >
                  <Translate langKey={"Delete-Profile"} />
                </CustomButton>
              </div>
            )}
        </div>
      </div>
      {/* <div style={{ position: "absolute" }}> */}
      <div style={{ position: "absolute", overflow: "hidden", width: "100%" }}>
        <MenuScreen
          navigate={navigateToScreen}
          handleMenuselection={handleMenuselection}
          shouldCloseMenu={shouldCloseMenu}
          handleRightButton={handleRightButton}
          isLogedIn={isLogedIn}
          appNavigate={navigate}
          handleLogout={handleLogout}
          handleExit={handleExit}
        />
      </div>
      <div
        style={{
          position: "absolute",
        }}
      >
        <ModalScreen
          shouldShowError={shouldShowModal}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
      </div>

      <div
        style={{
          position: "absolute",
        }}
      >
        <AuthFailModal
          shouldShowError={shouldShowAuthModal}
          errTitle={errTitle}
          errDescription={errDescription}
          errIcon={errIcon}
          button={button}
          iconWdth={iconWdth}
          iconHeight={iconHeight}
          modalOKButtonHandler={modalOKButtonHandler}
          modalCANCELButtonHandler={modalCANCELButtonHandler}
        />
      </div>
      {/* </div> */}
    </div>
  );
};

export default MyProfile;